import { useEffect, useRef, useState } from "react"

import classes from "./CopyText.module.css"

const COPIED_FEEDBACK_MS = 1500

export default function CopyIconButton({ textToCopy, title }) {
    const defaultMessage = title ?? "Copy"
    const [tooltipText, setTooltipText] = useState(defaultMessage)
    const [showTooltip, setShowTooltip] = useState(false)
    const copiedFeedbackRef = useRef(false)
    const resetTimerRef = useRef(null)

    useEffect(() => {
        return () => {
            if (resetTimerRef.current) {
                clearTimeout(resetTimerRef.current)
            }
        }
    }, [])

    const showCopiedFeedback = (message) => {
        copiedFeedbackRef.current = true
        setTooltipText(message)
        setShowTooltip(true)

        if (resetTimerRef.current) {
            clearTimeout(resetTimerRef.current)
        }

        resetTimerRef.current = setTimeout(() => {
            copiedFeedbackRef.current = false
            setShowTooltip(false)
            setTooltipText(defaultMessage)
        }, COPIED_FEEDBACK_MS)
    }

    const pointerEnterHandler = () => {
        if (copiedFeedbackRef.current) {
            return
        }
        setTooltipText(defaultMessage)
        setShowTooltip(true)
    }

    const pointerLeaveHandler = () => {
        if (copiedFeedbackRef.current) {
            return
        }
        setShowTooltip(false)
    }

    const copyHandler = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy ?? "")
            showCopiedFeedback("Copied")
        } catch (e) {
            showCopiedFeedback("Copy failed")
        }
    }

    return (
        <span className={classes.identifier}>
            <button
                type="button"
                onClick={copyHandler}
                onPointerEnter={pointerEnterHandler}
                onPointerLeave={pointerLeaveHandler}
                className={classes.copy_button}
                disabled={textToCopy == null}
            >
                <i className="ti ti-copy"></i>
                {showTooltip && (
                    <span className={classes.message_right}>{tooltipText}</span>
                )}
            </button>
        </span>
    )
}
